import { Modal, Form, Input, Button } from "antd";

const DuplicateTransactionReasonForm = (props) => {
  const { open, setVisible, onCreate } = props;
  const [form] = Form.useForm();

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={open}
      title="Reason for Duplicate Transaction"
      width={450}
      className="duplicationTransactionReasonModal"
      onCancel={() => {
        setVisible(false);
      }}
      footer={[
        <div key="footer" className="modalBtns">
          <Button
            className="defaultBtn defaultGreyBtn"
            onClick={() => {
              setVisible(false);
            }}
          >
            Cancel
          </Button>

          <Button className="defaultBtn" onClick={handleCreate}>
            Submit
          </Button>
        </div>,
      ]}
    >
      <Form form={form}>
        <Form.Item
          label={
            <span
              style={{
                whiteSpace: "normal",
              }}
            >
              This is a duplicate entry. Please give a reason why the same
              transaction ID needs to be audited again.
            </span>
          }
          name="transactionDuplicateReason"
          rules={[{ required: true, message: "Please input the reason!" }]}
          labelAlign="left"
          className="transactionDuplicateReason"
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DuplicateTransactionReasonForm;
